export default {
  haulers: 'Vedurid',
  setup: 'Seadistamine',
  driverExperience: 'Juhi kogemus',
  users: 'Kasutajad',
};
